import styled from 'styled-components';

export const AppShell = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const AppShellBody = styled.div`
  flex: 1;
  min-height: 0;
`;
